import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { InstanceService } from '../../../core/services/instance.service';
import { take } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { GeoLinkUtil } from '../../../../helpers/geo-link.util';
import { ZenithToastService } from '../../../components/zenith/zenith-toast/zenith-toast.service';
import { Icon, ZenithAppearance } from '../../../components/zenith/zenith-enums';


@Component({
  selector: 'app-find-instance',
  templateUrl: './find-instance.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule, ZenithComponentsModule],
})
export class FindInstanceComponent {
  @Input() transportId: string;
  readonly loading$ = new BehaviorSubject<boolean>(false);
  location$ = new BehaviorSubject<{ url: string, timestamp: string }>(null)

  constructor(
    private readonly toastService: ZenithToastService,
    private readonly translateService: TranslateService,
    private readonly instanceService: InstanceService,
  ) {
  }

  public findMachine() {
    this.loading$.next(true);

    this.instanceService.getLocation(this.transportId)
      .pipe(take(1))
      .subscribe({
        next: (machineLocation) => this.location$.next({
          url: GeoLinkUtil.toGeoLink(machineLocation),
          timestamp: machineLocation.timestamp,
        }),
        error: (_) => this.showGeneralToastError(),
      }).add(() => this.loading$.next(false));
  }

  private showGeneralToastError() {
    this.toastService.showToast(this.translateService.instant('MESSAGE.MACHINE_LOCATION_UNAVAILABLE'), ZenithAppearance.ERROR, Icon.ERROR);
  }
}
